import { useQuery } from "@tanstack/react-query";
import { CONNECT_USER_INVITATIONS_QUERY_KEY } from "../../features/Users/constants";
import { fetchConnectUserInvitations } from "../../services/users";
import useOrgId from "../organizations/useOrgId";

export default function useConnectUserInvitations(page = 1) {
  const orgId = useOrgId();
  return useQuery(
    [CONNECT_USER_INVITATIONS_QUERY_KEY, orgId, page],
    () => fetchConnectUserInvitations(page),
    {
      refetchOnWindowFocus: false,
      retry: false,
    }
  );
}
